import Constants from './Constants';

const Environment = {
  server(): string {
    if (Constants.ENV === Constants.DEV) {
      return Constants.DEV_SERVER;
    } else if (Constants.ENV === Constants.STAGING) {
      return Constants.STAGING_SERVER;
    } else {
      return Constants.PRODUCTION_SERVER;
    }
  },
  socket(): string {
    if (Constants.ENV === Constants.DEV) {
      return Constants.DEV_SOCKET;
    } else if (Constants.ENV === Constants.STAGING) {
      return Constants.STAGING_SOCKET;
    } else {
      return Constants.PRODUCTION_SOCKET;
    }
  },

  iPhone(): boolean {
    const ua = navigator.userAgent;
    return ua.indexOf('iPhone') > -1;
  },
  iOS(): boolean {
    const ua = navigator.userAgent;
    return ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1;
  },
  Android(): boolean {
    const ua = navigator.userAgent;
    return ua.indexOf('Android') > -1;
  }
};

export default Environment;



// WEBPACK FOOTER //
// ./src/common/Environment.ts